import InputSpinner from './InputSpinner';

export default InputSpinner;
